// TODO: Delete this file when movefile Task is no longer needed(ref:#2465, #2494)
import * as R from 'ramda';
import {
  GetTenantUsingMoveFileTaskQuery,
  GetTenantUsingMoveFileTaskQueryVariables,
} from '@/API';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { getTenantUsingMoveFileTask } from '@/graphql/queries';

export const isTenantUsingMoveFileTask = async (
  tenant: string
): Promise<boolean> => {
  const result = await graphqlQuery<
    GetTenantUsingMoveFileTaskQuery,
    GetTenantUsingMoveFileTaskQueryVariables
  >(getTenantUsingMoveFileTask, { tenant });
  const fetchedTenantUsingMoveFileTask: string | undefined = R.path(
    ['getTenantUsingMoveFileTask', 'tenant'],
    result
  );
  return Boolean(fetchedTenantUsingMoveFileTask);
};
